export const BILL_FREQUENCY_NAME = {
  Monthly: 'Month',
  BiMonthly: 'Bi-Monthly',
  Trimonthly: 'Quarterly',
  Annually: 'Annually'
};
export const BILL_FREQUENCY = {
  Monthly: 'Monthly',
  BiMonthly: 'BiMonthly',
  Trimonthly: 'Trimonthly',
  Annually: 'Annually'
};
export const ALLOCATION_METHOD = {
  ByOccupancy: 'ByOccupancy',
  ByUnit: 'ByUnit',
  BySquareFootage: 'BySquareFootage',
  ByPercentageShare: 'ByPercentageShare',
  BySubmeter: 'BySubmeter',
  By50Occupancy50SquareFootage: 'By50Occupancy50SquareFootage'
};
export const VACANT_UNIT_ALLOCATIONS = {
  AllocateToOwner: 'AllocateToOwner',
  DivideAmongOccupied: 'DivideAmongOccupied',
  NA: 'NA'
};
export const VACANT_UNIT_ALLOCATIONS_TO_PAID_BY = {
  AllocateToOwner: 'Owner',
  DivideAmongOccupied: 'Resident',
  NA: 'NA'
};
export const PAID_BY_TO_VACANT_UNIT_ALLOCATIONS = {
  Owner: 'AllocateToOwner',
  Resident: 'DivideAmongOccupied',
  NA: 'NA'
};
export const VACANT_UNIT_USAGE = {
  NoUsage: 'NoUsage',
  LimitedUsage: 'LimitedUsage',
  NormalUsage: 'NormalUsage'
};
export const VACANT_UNIT_USAGE_TO_TRANSLATE = {
  NoUsage: 'add_new_property_flow.no_usage',
  LimitedUsage: 'add_new_property_flow.unit_usage_limited_usage',
  NormalUsage: 'add_new_property_flow.full_usage'
};
export const UTILITIES_STATUSES = {
  PendingCompletion: 'PendingCompletion',
  PendingApproval: 'PendingApproval',
  TableReady: 'TableReady',
  TableReadyStatementSent: 'TableReadyStatementSent',
  TableSkipped: 'TableSkipped'
};
export const UTILITY_CONFIGURATION_TYPES = {
  UtilityConfigurator: 'utilityConfigurator',
  CustomUtilityProviderConfigurator: 'customUtilityProviderConfigurator',
  EditCustomUtilityProviderConfigurator: 'editCustomUtilityProviderConfigurator'
};
export const skipReasonTypes = t => ({
  BillCopyIsNotAvailable: t('allocations.skipped_bill_copy_not_available'),
  NoActiveResidents: t('allocations.skipped_no_active_residents'),
  OffCycle: t('allocations.skipped_off_cycle'),
  Other: t('allocations.skipped_other')
});
export const billStatuses = t => ({
  PendingApproval: {
    label: t('allocations.to_approve'),
    variant: 'info'
  },
  PendingCompletion: {
    label: t('allocations.pending_completion'),
    variant: 'warning'
  },
  SubmeterChargesSent: {
    label: t('allocations.sent_out'),
    variant: 'success'
  },
  TableReady: {
    label: t('allocations.table_is_ready'),
    variant: 'success'
  },
  TableReadyStatementSent: {
    label: t('allocations.sent_out'),
    variant: 'successBold'
  },
  TableSkipped: {
    label: t('allocations.skipped'),
    variant: 'critical'
  }
});